const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_PLACES_BOOT_API_KEY;

export async function lookupZip(zip) {
  if (!zip || !zip.trim()) {
    throw new Error("ZIP is required");
  }

  if (!GOOGLE_API_KEY) {
    throw new Error("Missing REACT_APP_GOOGLE_PLACES_BOOT_API_KEY");
  }

  const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
    zip.trim()
  )}&key=${GOOGLE_API_KEY}`;

  const res = await fetch(url);
  const data = await res.json();

  if (data.status !== "OK" || !data.results || data.results.length === 0) {
    throw new Error(data.status || "NO_RESULTS");
  }

  const components = data.results[0].address_components || [];

  const cityComp =
    components.find((c) => c.types.includes("locality")) ||
    components.find((c) => c.types.includes("administrative_area_level_2"));

  const stateComp = components.find((c) =>
    c.types.includes("administrative_area_level_1")
  );

  const countryComp = components.find((c) =>
    c.types.includes("country")
  );

  return {
    city: cityComp?.long_name || "",
    state: stateComp?.long_name || "",
    country: countryComp?.long_name || "",
  };
}
